import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_AlertWarning = _resolveComponent("AlertWarning")!
  const _component_InputCheckboxMultiSelect = _resolveComponent("InputCheckboxMultiSelect")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.searchPageUI.getError(),
      class: "mb-4"
    }, null, 8, ["error"]),
    (_ctx.AuthContext.isDpUser())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          novalidate: ""
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_InputText, {
              modelValue: this.customerCriteria.search_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.customerCriteria.search_name) = $event)),
              onInput: this.searchCustomers,
              label: `${_ctx.$t('searchCustomer')}...`,
              name: "search_customer",
              errors: errors
            }, null, 8, ["modelValue", "onInput", "label", "errors"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_GenericFormWrapper, {
      pageUI: _ctx.pageUI,
      "submit-data": _ctx.submitData,
      "submit-button-translation-key": "copy",
      "hide-feedback-status": ""
    }, {
      content: _withCtx(({ errors }) => [
        _createVNode(_component_InputSelect, {
          modelValue: _ctx.customerCodeCopyTo,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerCodeCopyTo) = $event)),
            _ctx.onFormDataChanged
          ],
          options: _ctx.customerOptions,
          label: _ctx.$t('copyTo'),
          name: "copy_to",
          selectText: _ctx.$t('selectText'),
          rules: "required",
          errors: errors
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"]),
        (_ctx.ignorableExceptions.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_AlertWarning, {
                message: _ctx.$t('copyIgnoreErrorsIntro')
              }, null, 8, ["message"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ignorableExceptions, (exception) => {
                return (_openBlock(), _createBlock(_component_InputCheckboxMultiSelect, {
                  key: exception.code,
                  modelValue: _ctx.ignoreAppErrorCodes,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ignoreAppErrorCodes) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  label: exception.message,
                  value: String(exception.code),
                  name: "ignore_app_error_codes",
                  errors: errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "value", "errors"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["pageUI", "submit-data"])
  ], 64))
}